
<nav-bar></nav-bar>
<div class="page-details column scroller" id="pdfExport" *ngIf="fields" [class.isExporting]="isExporting">
  <w-validation-panel *ngIf="doc.api_failed" type="warning" details="{{'page_full.warning_latest_copy' | translate}}"></w-validation-panel>
  <div class="nameAndButtons flex space-between">
    <h1 [title]="fields.wordMarkSpecification.markVerbalElement?.content">{{ fields.wordMarkSpecification.markVerbalElement?.content }}</h1>
    <div class="buttons flex noprint" *ngIf="windowWidth > 800">
      <button w-button *ngIf="ss.searchResult.docs.length" (click)="backToResults()">
        <div class="ellipsis">{{ ("page_full.return_to_" + (ms.endpoint==="reports" ? "reports" : "results")) | translate }}</div>
      </button>
      <button w-button (click)="exportAsPDF()">{{ 'buttons.export_to_pdf' | translate }}</button>
      <button w-button *ngIf="!isNewTab" (click)="openNewTab()" style="margin-right:1ch">{{ 'page_full.open_new_tab' | translate }}</button>
      <div class="prevNext flex" *ngIf="ss.searchResult.hasPrev() || ss.searchResult.hasNext()">
        <button w-button [disabled]="!ss.searchResult.hasPrev()" title="{{ 'general_words.previous' | translate }}" (click)="prevDoc()">
          <div class="ellipsis">&larr;</div>
        </button><span class="nobreak" *ngIf="ss.searchResult.numFound > 0">{{ ss.searchResult.cursor | number }} / {{ ss.searchResult.numFound | number }}</span>
        <button w-button [disabled]="!ss.searchResult.hasNext()" title="{{ 'general_words.next' | translate }}" (click)="nextDoc()">
          <div class="ellipsis">&rarr;</div>
        </button>
      </div>
    </div>
  </div>
  <div class="infoAndStatus flex center-v"><img class="status noprint" [src]="'/assets/images/status/' + doc.gbdStatus + '.svg'">
    <h3>{{ 'status.' + doc.gbdStatus | translate | uppercase }} {{ doc.type }} - {{ 'office.' + doc.registrationOfficeCode | translate }} ({{'designation.' + doc.registrationOfficeCode | translate}})</h3>
  </div>
  <div class="isMock" *ngIf="isMock">Notice : using mock data</div>
  <altcha-widget [challengeurl]="captchaURL" auto="onload" hidefooter="true" hidelogo="true" (verified)="onVerify($event, 'ev2')"></altcha-widget>
  <altcha-widget [challengeurl]="captchaURL" auto="onload" hidefooter="true" hidelogo="true" (verified)="onVerify($event, 'ev1')"></altcha-widget>
  <div class="textBlock">
    <ul class="columns">
      <li class="flex column col-33">
        <doc-field *ngIf="ev1" [field]="fields.applicationNumber"></doc-field>
        <doc-field *ngIf="ev2" [field]="fields.registrationNumber"></doc-field>
        <doc-field [field]="fields.kind"></doc-field>
        <doc-field [field]="fields.markFeature"></doc-field>
        <doc-field [field]="fields.goodsServicesClassification.classes"></doc-field>
      </li>
      <li class="flex column col-33">
        <doc-field [field]="fields.applicationDate"></doc-field>
        <doc-field [field]="fields.publicationDate"></doc-field>
        <doc-field [field]="fields.registrationDate"></doc-field>
        <doc-field [field]="fields.woao.pdf"> </doc-field><span *ngIf="doc.registrationOfficeCode != 'DE'">
          <doc-field [field]="fields.expiryDate"></doc-field></span>
        <doc-field [field]="fields.terminationDate"></doc-field>
      </li>
      <li class="logos flex column col-33">
        <!--span(*ngIf!="images?.length > 0 && !(doc.registrationOfficeCode == 'WO' && doc.gbdStatus == 'Pending')" )
        //doc-field([field]="fields.logo")
        //{{ 'general_words.logo' | translate | uppercase }}

        -->
        <ul class="flex column" *ngIf="images?.length > 0 && !(doc.registrationOfficeCode == 'WO' && doc.gbdStatus == 'Pending')">
          <li class="flex column center-v" *ngFor="let img of images;  let index = index"><span class="image" [ngStyle]="{'background-image' : 'url('+ images_blob_th[img] +')'}" [tippy]="tippyTemplateDetails"></span>
            <ng-template #tippyTemplateDetails>
              <div class="logoBig"><img src="{{images_blob_big[img]}}" alt="{{fields.wordMarkSpecification.markVerbalElement?.content}}"></div>
            </ng-template><a class="noprint" (click)="findSimilarImages(get_th_image(img))">{{ 'page_full.find_similar_logos' | translate }}</a>
          </li>
        </ul>
        <doc-field [field]="fields.wordMarkSpecification.markVerbalElement"></doc-field>
        <doc-field [field]="fields.wordMarkSpecification.markSignificantVerbalElement"></doc-field>
      </li>
    </ul>
  </div>
  <h3 *ngIf="doc.hasNamesAddresses">{{ 'page_full.names_and_addresses' | translate | uppercase }}</h3>
  <altcha-widget [challengeurl]="captchaURL" auto="onload" hidefooter="true" hidelogo="true" (verified)="onVerify($event, 'ev3')"></altcha-widget>
  <div class="textBlock names-addresses" *ngIf="doc.hasNamesAddresses">
    <ul class="columns">
      <li class="column col-33" *ngIf="doc.hasApplicants">
        <h4 *ngIf="!doc.hasHolders || !doc.hasDifferentApplicantsHolders">{{ 730 }} {{ 'inids.730' | translate | uppercase }}</h4>
        <h4 *ngIf="doc.hasHolders && doc.hasDifferentApplicantsHolders">{{ 731 }} {{ 'inids.731' | translate | uppercase }}</h4>
        <div *ngFor="let item of fields.applicants; let last = last;">
          <doc-field [field]="item.fullName"></doc-field>
          <doc-field [field]="item.kind"></doc-field>
          <doc-field [field]="item.fullAddress" *ngIf="item.fullAddress"></doc-field>
          <doc-field *ngIf="ev3" [field]="item.countryCode"></doc-field><br *ngIf="!last">
        </div>
      </li>
      <li class="column col-33" *ngIf="doc.hasHolders && doc.hasDifferentApplicantsHolders">
        <h4>{{ 732 }} {{ 'inids.732' | translate | uppercase }}</h4>
        <div *ngFor="let item of fields.holders; let last = last;">
          <doc-field [field]="item.fullName"></doc-field>
          <doc-field [field]="item.kind"></doc-field>
          <doc-field [field]="item.fullAddress" *ngIf="item.fullAddress"></doc-field>
          <doc-field *ngIf="ev3" [field]="item.countryCode"></doc-field><br *ngIf="!last">
        </div>
      </li>
      <li class="column col-33" *ngIf="doc.hasRepresentatives">
        <h4>{{ 740 }} {{ 'inids.740' | translate | uppercase }}</h4>
        <div *ngFor="let item of fields.representatives; let last = last;">
          <doc-field [field]="item.fullName"></doc-field>
          <doc-field [field]="item.kind"></doc-field>
          <doc-field [field]="item.fullAddress" *ngIf="item.fullAddress"></doc-field>
          <doc-field [field]="item.countryCode"></doc-field><br *ngIf="!last">
        </div>
      </li>
      <li class="column col-33" *ngIf="doc.hasCorrespondence">
        <h4>{{ 750 }} {{ 'inids.750' | translate | uppercase }}</h4>
        <doc-field [field]="fields.correspondence.fullName"></doc-field>
        <doc-field [field]="fields.correspondence.fullAddress" *ngIf="fields.correspondence.fullAddress"></doc-field>
        <doc-field [field]="fields.correspondence.countryCode"></doc-field>
      </li>
      <li class="column col-33" *ngIf="fields.wotm.legalNature">
        <h4>{{ 'page_full.madrid_specific' | translate | uppercase }}</h4>
        <doc-field [field]="fields.wotm.holderNationtalityCC"></doc-field>
        <doc-field [field]="fields.wotm.holderEstablishmentCC"></doc-field>
        <doc-field [field]="fields.wotm.legalNature"></doc-field>
      </li>
    </ul>
  </div>
  <h3 *ngIf="doc.hasClassification">{{ 'general_words.classification' | translate | uppercase }}</h3>
  <altcha-widget [challengeurl]="captchaURL" auto="onload" hidefooter="true" hidelogo="true" (verified)="onVerify($event, 'ev4')"></altcha-widget>
  <div class="textBlock classification" *ngIf="doc.hasClassification">
    <div class="block niceClassification" *ngIf="doc.hasNiceClassification">
      <h4>{{ 511 }} <span>{{ 'general_words.niceClassFull' | translate | uppercase }}</span><span *ngIf="fields.goodsServicesClassification.version">- NCL({{ fields.goodsServicesClassification.version }})</span></h4>
      <ul class="columns">
        <li class="column col-100">
          <div *ngFor="let terms of fields.goodsServicesClassification.terms, let last = last;">
            <doc-field *ngIf="!last || (last && ev4)" [field]="terms"></doc-field>
          </div>
        </li>
      </ul>
    </div>
    <div class="block nationalClassification" *ngIf="doc.hasNationalClassification">
      <h4>{{ 512 }} {{ 'inids.512' | translate | uppercase }}</h4>
      <ul class="columns">
        <li class="column col-100" *ngFor="let terms of fields.nationalGoodsServicesClassification.terms">
          <doc-field [field]="terms"></doc-field>
        </li>
      </ul>
    </div>
    <div class="block unClassification" *ngIf="doc.hasUnclassifiedClassification">
      <h4>{{ 510 }} {{ 'inids.510' | translate | uppercase }}</h4>
      <ul class="columns">
        <li class="column col-100">
          <doc-field [field]="fields.goodsServicesUnclassified"></doc-field>
        </li>
      </ul>
    </div>
    <div class="block imageClassification" *ngIf="fields.markImageDetails?.classification?.content?.length">
      <h4>{{ fields.markImageDetails?.classification?.code }} {{ fields.markImageDetails?.classification?.label | translate | uppercase }}<span *ngIf="fields.markImageDetails?.classification?.version">- {{ fields.markImageDetails.classification.version }}</span></h4>
      <ul class="columns">
        <li class="column col-100">
          <doc-field *ngFor="let terms of fields.markImageDetails?.classification?.content" [field]="terms"></doc-field>
        </li>
      </ul>
    </div>
  </div>
  <h3 *ngIf="(doc.priorities || doc.reference) && (doc.st13.substring(0,4) != 'WO80' && doc.st13.substring(0,4) != 'WO81')">{{ 'page_full.priority_related' | translate | uppercase }}</h3>
  <altcha-widget [challengeurl]="captchaURL" auto="onload" hidefooter="true" hidelogo="true" (verified)="onVerify($event, 'ev5')"></altcha-widget>
  <div class="textBlock related" *ngIf="(doc.priorities || doc.reference) && (doc.st13.substring(0,4) != 'WO80' && doc.st13.substring(0,4) != 'WO81') ">
    <ul class="columns">
      <li class="column" *ngIf="doc.priorities && ev5">
        <h4>{{ 300 }} {{ 'inids.300_Madrid' | translate | uppercase }}</h4>
        <div *ngFor="let priority of fields.priorities; let last = last;">
          <doc-field [field]="priority.number" *ngIf="ev5"></doc-field>
          <doc-field [field]="priority.date"></doc-field>
          <doc-field [field]="priority.countryCode"></doc-field>
          <doc-field *ngIf="!priority.countryCode" [field]="priority.countryName"></doc-field>
          <doc-field [field]="priority.comment"></doc-field><br *ngIf="!last">
        </div>
      </li>
      <li class="column" *ngIf="doc.reference?.office === 'WO'">
        <h4>{{ 832 }} {{ 'inids.832' | translate | uppercase }}</h4>
        <doc-field [field]="fields.reference.office"></doc-field>
        <doc-field [field]="fields.reference.registration[0]?.number"></doc-field>
        <doc-field [field]="fields.reference.registration[0]?.date"></doc-field>
      </li>
      <li class="column" *ngIf="doc.reference?.office !== 'WO' && doc.reference?.application">
        <h4>{{ 821 }} {{ 'inids.821' | translate | uppercase }}</h4>
        <doc-field [field]="fields.reference.office"></doc-field>
        <div *ngFor="let ref of fields.reference.application">
          <doc-field [field]="ref.office"></doc-field>
          <doc-field [field]="ref.number"></doc-field>
          <doc-field [field]="ref.date"></doc-field>
        </div>
      </li>
      <li class="column" *ngIf="doc.reference?.office !== 'WO' && doc.reference?.registration">
        <h4>{{ 822 }} {{ 'inids.822' | translate | uppercase }}</h4>
        <doc-field [field]="fields.reference.office"></doc-field>
        <div *ngFor="let ref of fields.reference.registration">
          <doc-field [field]="ref.office"></doc-field>
          <doc-field [field]="ref.number"></doc-field>
          <doc-field [field]="ref.date"></doc-field>
        </div>
      </li>
    </ul>
  </div>
  <h3>{{ 'general_words.office' | translate | uppercase }} - {{ ('office.' + doc.registrationOfficeCode) | translate }} ({{('designation.' + doc.registrationOfficeCode) | translate}})</h3>
  <altcha-widget [challengeurl]="captchaURL" auto="onload" hidefooter="true" hidelogo="true" (verified)="onVerify($event, 'ev6')"></altcha-widget>
  <div class="textBlock office">
    <ul class="columns">
      <li class="column col-33 logo">
        <div *ngIf="doc.link2office"><a [href]="doc.link2office" target="_blank"><img src="/assets/images/offices/{{ doc.registrationOfficeCode }}.png"></a></div>
        <div *ngIf="!doc.link2office"><img src="/assets/images/offices/{{ doc.registrationOfficeCode }}.png"></div>
      </li>
      <li class="column col-66">
        <doc-field [field]="fields.officeStatus"></doc-field>
        <doc-field [field]="fields.statusDate"></doc-field>
        <doc-field [field]="fields.designatedCountries" *ngIf="ev6"></doc-field>
      </li>
    </ul>
  </div>
  <div class="textBlock disclaimer">
    <p><span>{{'page_full.disclaimer' | translate}}</span><span class="noprint" *ngIf="doc.link2item"><a [href]="doc.link2item" target="_blank">{{'page_full.disclaimer_click' | translate}}</a></span></p>
  </div>
  <h3 *ngIf="doc.hasLicenceInformation">{{ 'page_full.licence_information' | translate | uppercase }}</h3>
  <altcha-widget [challengeurl]="captchaURL" auto="onload" hidefooter="true" hidelogo="true" (verified)="onVerify($event, 'ev7')"></altcha-widget>
  <div class="textBlock" *ngIf="doc.hasLicenceInformation">
    <ul class="columns">
      <li class="column col-33" *ngFor="let licence of fields.licences; let last = last;">
        <div>
          <doc-field [field]="licence.licenceCategory"></doc-field>
          <doc-field [field]="licence.licenceStatus"></doc-field>
          <div *ngFor="let theLicensee of licence.licensee">
            <div class="field"> <span class="inid">791</span><span class="label">{{ 'inids.791' | translate }}</span></div>
            <doc-field [field]="theLicensee.fullName"></doc-field>
            <doc-field [field]="theLicensee.fullAddress"></doc-field>
          </div>
          <doc-field [field]="licence.goodsServicesLimitation"></doc-field>
          <doc-field [field]="licence.licenceDate"></doc-field>
          <doc-field [field]="licence.effectiveDate"></doc-field>
          <doc-field [field]="licence.periodLimitationEndDate"></doc-field><br *ngIf="!last">
        </div>
      </li>
    </ul>
  </div>
  <h3>{{ 'page_full.general_info' | translate | uppercase }}</h3>
  <altcha-widget [challengeurl]="captchaURL" auto="onload" hidefooter="true" hidelogo="true" (verified)="onVerify($event, 'ev7')"></altcha-widget>
  <div class="textBlock">
    <ul class="columns">
      <li class="column col-50" *ngIf="doc.hasPublicationInformation">
        <h4>{{ 'page_full.publication_information' | translate }}</h4>
        <div *ngFor="let publication of fields.publications; let last = last;">
          <doc-field [field]="publication.identifier"></doc-field>
          <doc-field [field]="publication.date"></doc-field>
          <doc-field [field]="publication.section"></doc-field><br *ngIf="!last">
        </div>
      </li>
      <li class="column col-50" *ngIf="doc.hasOppositionPeriod">
        <h4>{{ 'page_full.opposition_period' | translate }}</h4>
        <doc-field [field]="fields.oppositionPeriodStartDate"></doc-field>
        <doc-field [field]="fields.oppositionPeriodEndDate"></doc-field>
      </li>
      <li class="column col-50">
        <doc-field [field]="fields.filingPlace"></doc-field>
        <doc-field [field]="fields.applicationLanguageCode" *ngIf="ev7"></doc-field>
        <doc-field [field]="fields.wordMarkSpecification.markTranslation"></doc-field>
        <doc-field [field]="fields.wordMarkSpecification.markTransliteration"></doc-field>
        <doc-field [field]="fields.markDisclaimerDetails"></doc-field>
        <doc-field [field]="fields.markDescriptionDetails"></doc-field>
        <doc-field [field]="fields.markImageDetails.description"></doc-field>
        <doc-field *ngIf="fields.markImageDetails.colourClaimed"></doc-field>
        <doc-field *ngIf="fields.markImageDetails.colourIndicator"></doc-field>
        <div *ngFor="let item of fields.wo6ter; let last = last;">
          <doc-field [field]="item"></doc-field>
          <hr *ngIf="!last">
        </div>
      </li>
      <li class="column col-50">
        <doc-field [field]="fields.wotm.basic_application"></doc-field>
        <doc-field [field]="fields.wotm.date_priority"></doc-field>
        <doc-field [field]="fields.wotm.madridDesignatedCountrie"></doc-field>
        <doc-field [field]="fields.wotm.madridDesignatedCountrie96"></doc-field>
        <doc-field [field]="fields.wotm.markUseIntentCountries"></doc-field>
      </li>
      <li class="column col-50" *ngIf="fields.woao.events_woao">
        <h4>{{ 'page_full.events' | translate | uppercase }}</h4>
        <div *ngFor="let item of fields.woao.events_woao; let last = last;">
          <doc-field [field]="item"></doc-field>
        </div>
      </li>
    </ul>
  </div>
</div>
